export default "__VITE_ASSET__Cv7AoRSu__"